import { useEffect, useState } from 'react';

const navLinks = [
  { id: 'home', label: '首页' },
  { id: 'popular', label: '热门推荐' },
  { id: 'categories', label: '漫画分类' },
  { id: 'latest', label: '最新更新' },
  { id: 'features', label: '阅读体验' },
  { id: 'faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dark, setDark] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem('ff-night') === '1';
  });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add('dark');
      localStorage.setItem('ff-night', '1');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('ff-night', '0');
    }
  }, [dark]);

  const solid = scrolled || menuOpen;

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 shadow-sm border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav
        className="mx-auto max-w-7xl px-4 md:px-6 h-16 md:h-18 flex items-center justify-between"
        aria-label="主导航"
      >
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className={`flex items-center gap-2 font-heading text-2xl ${solid ? 'text-primary-500' : 'text-white'}`}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-moon-clear-fill text-lg"></i>
          </span>
          飞飞漫画网
        </a>

        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => scrollTo(link.id)}
              className={`whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${
                solid ? 'text-foreground-700 hover:text-primary-500' : 'text-white/90 hover:text-white'
              }`}
            >
              {link.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setDark((v) => !v)}
            aria-label={dark ? '切换到日间模式' : '切换到夜间模式'}
            title={dark ? '切换到日间模式' : '切换到夜间模式'}
            className={`flex h-9 w-9 items-center justify-center rounded-full border transition-colors cursor-pointer ${
              solid
                ? 'border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500'
                : 'border-white/40 text-white hover:bg-white/15'
            }`}
          >
            <i className={dark ? 'ri-sun-line text-base' : 'ri-moon-clear-line text-base'}></i>
          </button>

          <button
            type="button"
            onClick={() => scrollTo('features')}
            className="hidden md:inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            立即开始阅读
            <i className="ri-arrow-right-line text-sm"></i>
          </button>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            className={`md:hidden flex h-9 w-9 items-center justify-center rounded-md border cursor-pointer ${
              solid ? 'border-background-300 text-foreground-800' : 'border-white/40 text-white'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => scrollTo(link.id)}
                className="flex items-center justify-between border-b border-background-100 py-3 text-left text-sm font-medium text-foreground-700 cursor-pointer"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </button>
            ))}
            <button
              type="button"
              onClick={() => scrollTo('features')}
              className="mt-3 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 cursor-pointer"
            >
              立即开始阅读
            </button>
          </div>
        </div>
      )}
    </header>
  );
}